// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header screen="'PROFILE'">
  <button ng-if="\$ctrl.profile.status !== 'CLOSED'"
          type="button button-small"
          command-access="MergeCustomers"
          class="btn btn-primary"
          ng-click="\$ctrl.goToMergeWith()">
    Merge duplicated customers
  </button>
</customer-profile-header>
<section class="box">
  <sub-header header="'Customer profile'"></sub-header>

  <print-header branch-id="\$ctrl.profile.branchId" print-name="'Customer profile'"></print-header>

  <customer-profile-body profile="\$ctrl.profile"
                         module="'customer'"
                         single-page="\$ctrl.singlePage">
    <buttons-when-edit-disabled>
      <button type="button" class="btn btn-success" ng-click="\$ctrl.printCustomerProfile()">
        Print
      </button>

      <button type="button" class="btn btn-primary" ng-if="\$ctrl.profile.status === 'CLOSED'" ng-click="\$ctrl.reactivate()" command-access="ReactivateCustomer">
        Reactivate
      </button>
    </buttons-when-edit-disabled>
  </customer-profile-body>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/profile/existing/customer-profile-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;